export const logoutClassicWeb = () => {
  // note: This is ugly, but currently the only way to log out of classic, as that frame
  // are loading a bunch of other frames to do federated signout :'(
  const iframe = global.document.createElement('iframe');
  iframe.src = 'https://classic.sampension.dk/Forside/log-ind/din-pension/Log-ud';
  iframe.style.display = 'none';
  global.document.body.appendChild(iframe);
};
